module.exports = __webpack_public_path__ + "fonts/helvetica-now-display-light.c1fb6ec.woff2";